import { clone } from "lodash";

// 2.7.94 WSProductDisplay
export default class WSProductDisplay {
	constructor({
		group,
		order,
	}) {
		/**
		 * int
		 * (Required) Indicates the group number for grouping
		 * the products for display.
		 */
		this.group = group;

		/**
		 * int
		 * (Required) Order to display the product within its
		 * group.
		 */
		this.order = order;
	}

	static fromBackoffice(data) {
		const result = new WSProductDisplay(data);

		return result;
	}

	static fromSerialized(data) {
		const result = new WSProductDisplay(data);

		return result;
	}

	toBackoffice() {
		const result = clone(this);

		return result;
	}

	toResolver() {
		const forGraphql = clone(this);

		forGraphql.id = this.IDPROP;

		return forGraphql;
	}
}

export const WSProductDisplayType = [ `
		type WSProductDisplay {
			group: Int!
			order: Int!
		}
	`,
];
